import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Servicio
import { EmpleadosServicio } from '../../../services/empleado.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import { Router, ActivatedRoute, Params } from '@angular/router';

const ID_PAGINA = 29;

@Component({
  selector: 'app-lista-empleado',
  templateUrl: './lista-empleado.component.html',
  styleUrls: ['./lista-empleado.component.css']
})
export class ListaEmpleadoComponent implements OnInit {
  listaEmpleados: Observable<Array<Object>>;
  loaded = false;
  loading = false;
  datosEmpleado: any;
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  busqueda = '';
  empleadoSeleccionado = '';
  estadoSeleccionado = '1';

  constructor(
    private empleadoService: EmpleadosServicio,
    private modals: AlertasModales,
    private router: Router,
    private route: ActivatedRoute,
    ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.initEmpleados();
    this.datosEmpleado = this.empleadoService.datosEmpleado;
  }

  ngOnInit() {
    this.verificarQueryString();
  }

  private initEmpleados(): void {
    this.loading = true;
    this.empleadoService.listaEmpleado(
      String(this.empleadoSeleccionado),
      this.limit,
      this.offset,
      this.busqueda,
      this.estadoSeleccionado
    ).subscribe((res: any) => {
      this.listaEmpleados = res.empleados;
      this.size = res.total_items;
      this.loaded = true;
      this.loading = false;
    });
  }

  switchChage(e: Event, empleado) {
    e.preventDefault();
    if (this.empleadoService.datosEmpleado.tipo_empleado === 1 && empleado.tipo_empleado === 1) {
      // tslint:disable-next-line:max-line-length
      this.modals.validacionesModalJquery('Advertencia', 'No tienes acceso a esta función, solo el super administrador puede realizar esta función', 'orange', 'material');
    } else {
      const html = `<p>¿Estas seguro que deseas <b>${empleado.estado ? 'desactivar' : 'activar'}</b>
         el empleado <b>${empleado.nombre} ${empleado.apellido}</b></p>`;
      this.modals.confirmModalJquery('¿Estas seguro?', html, 'orange', 'material').then(resp => {
        if (resp && resp === 'SI') {
          const data = {
            ID_EMPLEADO: empleado.ID_EMPLEADO,
            editor: this.empleadoService.datosEmpleado.ID_EMPLEADO
          };
          this.empleadoService.activarDesactivarEmpleado(data)
          .subscribe(
            () => empleado.estado = !empleado.estado,
            err => {
              if (err.status == 403) {
                this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
      'red',
      'modern',
      false,
      'fa fa-thumbs-down');
              }
            }
          );
        }
      });
    }
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        if (params.busqueda) {
          this.busqueda = params.busqueda;
        }
        if (params.limite && !isNaN(params.limite)) {
          this.limit = params.limite;
        }
        if (params.tipo_empleado) {
          this.empleadoSeleccionado = params.tipo_empleado;
        }
        if (params.estado) {
          this.estadoSeleccionado = params.estado;
        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }

        this.initEmpleados();
      }
    });
  }

  public filtrar() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['busqueda'] = this.busqueda;
    queryParams['limite'] = this.limit;
    queryParams['tipo_empleado'] = this.empleadoSeleccionado;
    queryParams['estado'] = this.estadoSeleccionado;
 
    this.router.navigate(['./lista/empleado'], { queryParams: queryParams });
  }

  public loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/empleado'], { queryParams: queryParams });
    this.initEmpleados();
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/empleado/lista/lista-empleado.component.ts